import { chatApiAxios } from "@/plugins";
import { HttpRequestMethodEnum } from "@/types/api";

interface UpdateChat {
  chatId: string;
  name?: string;
  picture?: string;
  accessToken: string;
}

export const updateChatBeAsync = async ({
  chatId,
  name,
  picture,
  accessToken,
}: UpdateChat) => {
  const headers = {
    Authorization: `Bearer ${accessToken}`,
  };
  const res = await chatApiAxios("chat/" + chatId, {
    method: HttpRequestMethodEnum.PATCH,
    headers,
    data: {
      name,
      picture,
    },
  });
  return res.data;
};
